import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { fromEvent as observableFromEvent } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

import { ScrollToService } from "../../core";

import { SidebarSubsection } from "./types";

@Component({
  selector: "ta-subsection-headers",
  templateUrl: "./subsection-headers.template.html"
})
export class SubsectionHeadersComponent implements OnInit, OnDestroy {
  @Input()
  subsection: SidebarSubsection;

  hover: boolean = false;

  activeHeader: string = "";

  constructor(
    private route: ActivatedRoute,
    private scrollService: ScrollToService
  ) {}

  ngOnInit(): void {
    this.initFragmentSub();
    this.initActiveHeaderSub();
  }

  private initFragmentSub(): void {
    this.route.fragment
      .pipe(takeUntil(this.onDestroyEmitter))
      .subscribe((fragment: string) => {
        if (!fragment) {
          return;
        }

        const element = document.getElementById(fragment);

        if (element) {
          this.scrollService.scrollTo(element);
          this.activeHeader = element.innerText;
        }
      });
  }

  private initActiveHeaderSub(): void {
    observableFromEvent(document, "scroll")
      .pipe(
        debounceTime(50),
        takeUntil(this.onDestroyEmitter)
      )
      .subscribe(() => {
        const headers: HTMLHeadingElement[] = Array.from<HTMLHeadingElement>(
          document.querySelectorAll(".heading--1, .heading--2")
        )
          .filter((header) => {
            const rect = header.getBoundingClientRect();
            return rect.bottom >= -10 && rect.top <= window.innerHeight / 2;
          })
          .sort((headerA, headerB) => {
            const rectA = headerA.getBoundingClientRect(),
              rectB = headerB.getBoundingClientRect();
            return rectA.top - rectB.top;
          });

        if (headers.length === 0) {
          return;
        }

        this.activeHeader = headers[0].innerText;
      });
  }

  ngOnDestroy(): void {
    this.onDestroyEmitter.emit();
  }
  private onDestroyEmitter = new EventEmitter();
}
